import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M14.9027 2.0847A1 1 0 0 1 15.5 3v18a1.0002 1.0002 0 0 1-1.6402.7682L8.138 17H3c-.5523 0-1-.4477-1-1V8.5c0-.5523.4477-1 1-1h5.111l5.7133-5.2371a1 1 0 0 1 1.0784-.1782M13.5 5.2733 9.1757 9.2372A1 1 0 0 1 8.5 9.5H4V15h4.5c.234 0 .4605.082.6402.2318L13.5 18.865z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M17.5 15.8829V9.3876c0-.6826.6715-1.1694 1.2929-.8868C20.2795 9.1768 22 10.3797 22 12.5002c0 2.223-1.891 3.6475-3.4209 4.2237-.5578.21-1.0791-.245-1.0791-.841"
    }, "1")
], "CreativeAudio", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
